import BaseService from './_base.service';

export const cameraresolutionService = {
    page,
    edit,
    combo,
    search,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/camera/resolution/page/"+page+"/"+size, callback, true)
}
function combo(callback) {
    return BaseService.get("/camera/resolution/combo/", callback, true)
}
function search(page,size,filter, callback) {
    return BaseService.post("/camera/resolution/page/"+page+"/"+size,filter, callback, true)
}
function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/camera/resolution/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/camera/resolution/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/camera/resolution/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/camera/resolution/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/camera/resolution/"+id+"/logic", callback);
}
